<template>
  <div
    class="shipping-address"
    :class="address.checked ? 'cont_box02' : 'cont_box03'"
  >
    <p class="address-tit">
      <span class="address-name01">
        <input
          class="amwa-radio"
          type="radio"
          :checked="address.checked"
          @change="toggleRadio"
          :id="address.id"
        />
        <label :for="address.id"> {{ address.name }}</label>
      </span>
      <span class="address-type01" v-if="address.isRegularShipping">정기배송지</span>
      <span class="address-type01" v-if="address.isDefault">기본배송지</span>
    </p>
    <div class="detail-content pop_address">
      <div class="address_info_txt">
        [{{ address.defaultAddress.postalCode }}]{{
          address.defaultAddress.formattedAddress
        }}
      </div>
      <div class="address_info_txt">
        휴대폰 : {{ `${address.mobileArea}${address.mobileNumber}` }}
      </div>
      <div class="address_info_txt mgt20 withTooltip">
        <span class="sstit">배송메시지</span>
        <!-- 툴팁 -->
        <div class="toolTip-wrapper toolTip-type02 type-mob-full">
          <button
            type="button"
            class="btn-tooltip"
            @click="displayToolTip = !displayToolTip"
          >
            <span class="hidden">안내</span>
          </button>
          <div class="tipCont-wrapper" style="max-width: none">
            <div
              class="tooltip-content mobile01 pop"
              :style="
                displayToolTip ? { display: 'block' } : { display: 'none' }
              "
            >
              <ul class="list-type5">
                <li>
                  택배기사님께 전달하는 메시지는 배송 시 참고하는 내용으로
                  배송상황 및 요청내용에 따라 반영되지 않을 수 있습니다.
                </li>
                <li>배송일 및 배송시각은 지정하셔도 반영되지 않습니다.</li>
              </ul>
            </div>
          </div>
        </div>
        <!-- //툴팁 -->
        <span class="form_select-default mgt5">
          <select
            class="form_select"
            v-model="selectedMessage"
            @change="updateDeliveryMessage"
          >
            <option
              v-for="message in deliveryMessages"
              :key="message.code"
              :value="message"
            >
              {{ message.text }}
            </option>
          </select>
          <input
            v-if="selectedMessage.code == 'CDN01'"
            class="form_input mgt5"
            v-model="inputMessage"
            placeholder="특수문자는(),를 제외하고 입력이 불가합니다."
            @change="directInputMessage($event)"
            @input="onInput($event)"
          />
          <span
            v-if="selectedMessage.code == 'CDN01'"
            class="form_byte byte-txt"
            ref="refByte"
            >(0/40byte)</span
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import as400StringUtils from "@/utils/helpers/as400String";

export default {
  name: "AddressUnit",
  data() {
    return {
      displayToolTip: false,
      selectedMessage: {
        code: "CPN",
        text: "배송메시지 선택",
      },
      deliveryMessages: [
        {
          code: "CPN",
          text: "배송메시지 선택",
        },
        {
          code: "CDN01",
          text: "직접입력",
        },
        {
          code: "CDN02",
          text: "문 앞",
        },
        {
          code: "CDN03",
          text: "부재 시 문 앞",
        },
        {
          code: "CDN04",
          text: "부재 시 경비실",
        },
        {
          code: "CDN05",
          text: "택배함",
        },
      ],
      inputMessage: "",
    };
  },
  props: {
    address: {
      type: Object,
      required: true,
      default: () => {
        return {
          defaultAddress: {
            formattedAddress: "",
            postalCode: "",
          },
          id: "",
          mobileArea: "010",
          mobileNumber: "",
          name: "",
          index: 0,
          checked: false,
        };
      },
    },
    storedDeliveryInfo: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    const message = this.address.message;
    // 메시지가 존재하면 
    if(!!message) {
      const found = this.deliveryMessages.find(item => item.text === message);
      this.selectedMessage = {
        code: found ? found.code : "CDN01",
        text: found ? found.text : "직접입력",
      };

      if(this.selectedMessage.code == "CDN01") {
        this.inputMessage = message;
        this.updateDeliveryMessage();
      }

      // byte
      this.$nextTick(() => {
        if(this.$refs.refByte) {
          let byte = as400StringUtils.getAS400Byte(this.inputMessage);
          this.$refs.refByte.textContent = "(" + byte + "/40byte)";
        }
      });
    }
  },
  methods: {
    toggleRadio(event) {
      this.$emit("toggle-address-radio", this.address.index);
      this.updateDeliveryMessage();
    },
    updateDeliveryMessage() {
      if (this.address.checked) {
        let result = {
          ...this.selectedMessage,
        };
        if (result.code === "CDN01") {
          result.text = this.inputMessage;
        }
        this.$emit("update-delivery-message", result);
      }
    },
    directInputMessage(event) {
      this.removeSpecialChar(event, true);

      if (this.address.checked) {
        this.$emit("direct-input-message", event.target.value);
      }
    },
    removeSpecialChar(event, showMessage = false) {
      const allowedPattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9.\s)#-]/g;
      const inputVal = event.target.value;

      if (allowedPattern.test(inputVal)) {
        const cleanedVal = inputVal.replace(allowedPattern, "").trim();
        this.inputMessage = cleanedVal;

        if(showMessage) {
          alert("특수문자는 ( ) . - # 를 제외하고 입력이 불가합니다.");
        }
        return true;
      } else {
        this.inputMessage = inputVal.trim();
      }
      return false;
    },
    onInput(event) {
      let byte = as400StringUtils.getAS400Byte(event.target.value);
      if (byte > 40) {

        let message = "배송메세지는 40Bytes까지 입력 가능합니다.";
        this.removeSpecialChar(event, false);
        this.inputMessage = as400StringUtils.getAS400String(
          event.target.value,
          40
        );

        alert(message);
        byte = as400StringUtils.getAS400Byte(this.inputMessage);
      }
      this.$refs.refByte.textContent = "(" + byte + "/40byte)";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/main/components/DeliveryPopUpContents/AddressUnit.vue